import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    Injector,
    ChangeDetectorRef
} from '@angular/core';
import {Category, InventoryManager, Item, MenuManager, OrderManager, Setting, Store} from 'aigens-ng-core';
import {OrderService} from '../../core/services/order.service';

import {TranslateService} from '@ngx-translate/core';
import { MobileBasePage } from 'src/app/core/base/mobile-base-page';
import { DecimalPipe } from '@angular/common';
import { SystemConfigService } from 'src/app/core/services/systemConfig.service';

@Component({
    selector: 'app-grid-layout-item',
    templateUrl: './grid-layout-item.html',
    styleUrls: ['./grid-layout-item.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridLayoutItem implements OnInit, AfterViewInit, OnChanges {

    isParent: boolean;
    isSet = false;
    settings: Setting;
    _isSoldout: boolean;
    @Output() addClick = new EventEmitter();
    @Output() removeClick = new EventEmitter();
    @Input() currencySign: string;
    @Input() category: Category;
    @Input() imgs: Array<any>;
    @Input() tagsImage;
    @Input() index: number;
    @Input() orderManager: OrderManager;
    name: string;
    isEn: boolean;

    // tslint:disable-next-line: max-line-length
    constructor(private cdr: ChangeDetectorRef, private translateService: TranslateService, private inventoryManager: InventoryManager, private orderService: OrderService, private menuManager: MenuManager) {
        this.settings = this.orderService.getCurrentStoreSetting();
        // console.log(this.settings);
    }

    // need to Listening
    _quantity: number;

    @Input()
    set quantity(quantity: number) {
        this._quantity = quantity;
    }

    _item: Item;

    @Input()
    set item(item: Item) {
        this._item = item;
        this.onChange();
        // console.log('on item change');

    }

    ngOnInit() {
        // console.log('on item init');
    }

    onChange() {
        try {
            this.isParent = !!(this._item.variations && this._item.variations.length > 0);
            this.isSet = Item.isSet(this.category, this._item);
            this._isSoldout = this.getSoldout();
            this.name = this.getItemName();
            this.isEn = this.translateService.currentLang === 'en';
        } catch (e) {
            console.log(e);
        }

    }


    ngOnChanges(changes: SimpleChanges): void {
        // this.isParent = !!(this._item.variations && this._item.variations.length > 0);
        // this.isSet = Item.isSet(this.category, this._item);
        // this.isSoldout = this.getSoldout();
        // console.log('this.isSoldout', this.isSoldout);
        // this.name = this.getItemName();
        // this.isEn = this.translateService.currentLang === 'en';
    }

    ngAfterViewInit() {
    }

    getItemName() {
        let name: string = this._item.name;

        if (this.isParent) {
            name = this._item.title;
        }

        if (!name || name.length === 0) {
            name = this._item.name;
        }

        return name;
    }

    getSoldout(): boolean {
        let result: boolean;
        const imSoldout = this.inventoryManager.isSoldout(this._item);
        result = (!this.isParent && imSoldout);
        let now = this.convertNowDateToStoreTimeZone(this.orderManager.store.timezone).getTime();
        // const now = Date.now();
        return result || !this.menuManager.isAvailableCombo(this.orderManager.store, this.category, this._item, this.orderManager.isTakeout(), now);

    }

    convertNowDateToStoreTimeZone(timeZone): Date {
        timeZone = timeZone ? timeZone : 'GMT+8';
        let timeZoneValue = timeZone.split('GMT')[1];
        // let isPositive = timeZoneValue.startsWith('+');
        let integerTimeZoneValue = parseFloat(timeZoneValue);
        let now = new Date();
        now.setHours(now.getUTCHours() + integerTimeZoneValue);
        return now;
    }

    removeClicked() {
        this.removeClick.emit(this._item);
    }

    addClicked() {
        this.addClick.emit(this._item);
    }



}
